import { PlaycastMessageHeader, PlaycastMessageSource } from '../../types';
import { createId } from '@paralleldrive/cuid2';

export const generateMessageHeader = (id: string, source: PlaycastMessageSource, userAuth?: string): PlaycastMessageHeader => {
  const stamp = Date.now();

  const header: PlaycastMessageHeader = {
    tag: stamp.toString().concat('.', createId()),
    source,
    schemaVersion: 5,
    timestamp: stamp,
    user: {
      id,
      auth: userAuth ?? 'anonymous',
    },
  };
  return header;
};
